import React, { FC, ReactNode } from 'react'
import * as Dialog from '@radix-ui/react-dialog'
// import { Cross2Icon } from '@radix-ui/react-icons'
interface DocumentsModalProps {
    children: ReactNode
    isOpen: boolean
    setIsOpen(value: boolean): void
}
export const DocumentsModal: FC<DocumentsModalProps> = ({
    children,
    isOpen,
    setIsOpen,
}) => {
    return (
        <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
            <Dialog.Portal>
                <Dialog.Overlay className="bg-blackA6 data-[state=open]:animate-overlayShow fixed inset-0" />
                <Dialog.Content className="data-[state=open]:animate-contentShow fixed top-[50%] left-[50%] max-h-[85vh] w-[90vw] max-w-[650px] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-white shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none overflow-hidden flex flex-col">
                    <Dialog.Title className="text-mauve12 m-0 text-[17px] font-medium uppercase px-6 pt-6">
                        Enviar documentos
                    </Dialog.Title>
                    <div className="flex-1 flex w-full">{children}</div>
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    )
}
